import React from "react";
import { Footer, FooterText } from "./styles";
export default () => {
  return (
    <Footer>
      <FooterText>© 2020 FRANCISCO BUCCAFUSCA - MAPA DEL SITIO</FooterText>
    </Footer>
  );
};
